var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __decorateParam = (index, decorator) => (target, key) => decorator(target, key, index);

// db/signals.ts
import { Arg, Entity, Field, Mutation, Query, Subscription } from "@adornis/baseql/decorators.js";
import { AdornisEntity } from "@adornis/baseql/entities/adornisEntity.js";
import { registerMutation, registerQuery, registerSubscription } from "@adornis/baseql/metadata/register.js";
import "@adornis/baseql/utils/queryGeneration.js";
import "rxjs";
import { sendRTCSignalResolver, subscribeRTCSignalResolver } from "../server/resolver/signals.js";
import { getICEServers as getICEServersResolver } from "../server/twilio.js";
var ICEServer = class extends AdornisEntity {
};
ICEServer._class = "ICEServer";
__decorateClass([
  Field((type) => String)
], ICEServer.prototype, "url", 2);
__decorateClass([
  Field((type) => String)
], ICEServer.prototype, "urls", 2);
__decorateClass([
  Field((type) => String)
], ICEServer.prototype, "username", 2);
__decorateClass([
  Field((type) => String)
], ICEServer.prototype, "credential", 2);
ICEServer = __decorateClass([
  Entity()
], ICEServer);
var Signal = class extends AdornisEntity {
  constructor(doc) {
    super(doc);
  }
};
Signal._class = "Signal";
__decorateClass([
  Field((type) => String)
], Signal.prototype, "roomID", 2);
__decorateClass([
  Field((type) => String)
], Signal.prototype, "from", 2);
__decorateClass([
  Field((type) => String)
], Signal.prototype, "to", 2);
__decorateClass([
  Field((type) => String)
], Signal.prototype, "payload", 2);
Signal = __decorateClass([
  Entity()
], Signal);
var RTCSignal = class extends AdornisEntity {
  static sendRTCSignal(signal) {
    return sendRTCSignalResolver(signal);
  }
  static subscribeRTCSignal(roomID) {
    return subscribeRTCSignalResolver(roomID);
  }
  static getICEServers() {
    return async (gqlFields) => {
      return getICEServersResolver();
    };
  }
};
RTCSignal._class = "RTCSignal";
__decorateClass([
  Mutation((type) => Boolean),
  __decorateParam(0, Arg("signal", (type) => Signal))
], RTCSignal, "sendRTCSignal", 1);
__decorateClass([
  Subscription((type) => Signal),
  __decorateParam(0, Arg("roomID", (type) => String))
], RTCSignal, "subscribeRTCSignal", 1);
__decorateClass([
  Query((type) => [ICEServer])
], RTCSignal, "getICEServers", 1);
RTCSignal = __decorateClass([
  Entity()
], RTCSignal);
var sendRTCSignal = registerMutation({
  operationName: "sendRTCSignal",
  resolve: sendRTCSignalResolver,
  type: () => Boolean,
  params: [{ name: "signal", type: () => Signal }]
});
var subscribeRTCSignal = registerSubscription({
  operationName: "subscribeRTCSignal",
  resolve: subscribeRTCSignalResolver,
  type: () => Signal,
  params: [{ name: "roomID", type: () => String }]
});
var getICEServers = registerQuery({
  operationName: "getICEServers",
  resolve: () => async (gqlFields) => getICEServersResolver(),
  type: () => [ICEServer]
});
export {
  ICEServer,
  RTCSignal,
  Signal,
  getICEServers,
  sendRTCSignal,
  subscribeRTCSignal
};
